import { useEffect, useState } from "react";

import type { TranscriptData } from "../types";

type UseTranscriptStateParams = {
	transcriptData: TranscriptData;
	isTranscriptLoading: boolean;
};

type UseTranscriptStateReturn = {
	transcriptContent: string;
	setTranscriptContent: (content: string) => void;
	isTranscriptContentLoaded: boolean;
};

/**
 * Hook for managing transcript content state.
 * Handles initial content loading.
 * @param transcriptData - Parsed transcript data from useMeetingTranscript hook
 * @param isTranscriptLoading - Whether transcript is currently loading
 */
export const useTranscriptState = ({
	transcriptData,
	isTranscriptLoading,
}: UseTranscriptStateParams): UseTranscriptStateReturn => {
	const [transcriptContent, setTranscriptContent] = useState(transcriptData?.content || "");
	const [isTranscriptContentLoaded, setIsTranscriptContentLoaded] = useState(false);

	useEffect(() => {
		if (!isTranscriptLoading) {
			if (transcriptData?.content !== undefined) {
				setTranscriptContent(transcriptData.content);
				setIsTranscriptContentLoaded(true);
			}
		}
	}, [isTranscriptLoading, transcriptData?.content]);

	return {
		transcriptContent,
		setTranscriptContent,
		isTranscriptContentLoaded,
	};
};
